































import {
  computed, defineComponent, PropType, reactive,
} from '@vue/composition-api';
import { Mod } from '@c/landingpage/modpack/types';
import BaseAppModal from '@c/modal/BaseAppModal.vue';
import { useAsset } from '@a/plugins/assets';
import BaseModpackImage from '@c/landingpage/modpack/BaseModpackImage.vue';
import BaseModpackTagList from '@c/landingpage/modpack/BaseModpackTagList.vue';
import { useStore } from '@a/store';
import { useI18N } from '@a/composables/use-vue-i18n';

export default defineComponent({
  name: 'BaseModpackListItem',
  components: { BaseModpackTagList, BaseModpackImage, BaseAppModal },
  props: {
    value: {
      type: Object as PropType<Mod>,
      required: true,
    },
  },
  setup: (props, { emit }) => {
    const { modpackIcon } = useAsset();
    const { getters } = useStore();
    const i18n = useI18N();
    const state = reactive({
      showModal: false,
      icon: computed(() => modpackIcon(props.value.image)),
      tags: computed(() => getters['game/modTags']),
    });

    return {
      emit,
      state,
      i18n,
    };
  },
});
